export class Model_CRM_MonthOfBusiness {

    public MonthName: string;
    public MonthId: number;

}       
